import Vue from 'vue';
import store from './../../store';
import purchaseTransformer from './../../transformers/purchase';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const purchases = purchaseTransformer.fetchCollection(data.data);

  store.dispatch('FetchAllPurchases', purchases);
  resolve(purchases);
};

const failed = () => {
};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/purchases', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/all.js